import React from 'react'

// MUI Imports
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import { Typography } from '@mui/material'
import CirleSmall from 'mdi-material-ui/CircleSmall'
import { useTheme } from '@emotion/react'
import { useCheckoutUI } from 'src/lib/contexts/CheckoutUIContext'
import { Save } from 'react-feather'

interface CouponCardPreviewProps {
  title: string
  header?: string
  description?: string
  longDescription?: string[]
}

const CalloutCardPreview: React.FC<CouponCardPreviewProps> = ({ title, header, description, longDescription }) => {
  const theme: any = useTheme()
  const {
    getters: { checkoutUI }
  } = useCheckoutUI()

  const themeColor = checkoutUI?.colorPalette?.primaryColor?.substring(0, 7)
  const backgroundImage = `linear-gradient(180deg, ${themeColor}1A, transparent)`

  return (
    <div className='h-fit pb-3 rounded-xl min-w-[300px] max-w-[380px] flex flex-col border-1 border-gray-light bg-white overflow-hidden'>
      <div
        className='flex p-3 justify-between items-center border-b border-dashed border-gray-lightest'
        style={{
          backgroundImage: backgroundImage
        }}
      >
        <div className='flex items-center space-x-2 w-[272px] justify-start text-ellipsis overflow-hidden'>
          <svg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'>
            <path
              d='M3.64375 4.10735C3.82474 2.81935 5.16761 2.04405 6.37355 2.53131L7.25073 2.88573C7.73136 3.07993 8.26861 3.07993 8.74923 2.88573L9.62642 2.53131C10.8324 2.04405 12.1752 2.81935 12.3562 4.10735L12.4879 5.04423C12.56 5.55756 12.8286 6.02284 13.2371 6.34197L13.9826 6.92442C15.0076 7.72516 15.0076 9.27577 13.9826 10.0765L13.2371 10.659C12.8286 10.9781 12.56 11.4434 12.4879 11.9567L12.3562 12.8936C12.1752 14.1816 10.8324 14.9569 9.62641 14.4696L8.74923 14.1152C8.26861 13.921 7.73135 13.921 7.25073 14.1152L6.37355 14.4696C5.16761 14.9569 3.82474 14.1816 3.64375 12.8936L3.5121 11.9567C3.43997 11.4434 3.17134 10.9781 2.76285 10.659L2.01732 10.0765C0.992369 9.27577 0.99237 7.72516 2.01732 6.92442L2.76285 6.34197C3.17134 6.02284 3.43997 5.55756 3.5121 5.04423L3.64375 4.10735Z'
              stroke={themeColor}
              strokeWidth='1.5'
            />
          </svg>
          <span className='text-base font-medium text-carbon'>{Boolean(title) ? title : 'Title'}</span>
        </div>
      </div>
      <div className='p-3 flex flex-col items-start space-y-1 '>
        <span className='whitespace-nowrap text-sm font-semibold text-coal-dark'>
          {Boolean(header?.length) ? header : 'Subtitle'}
        </span>
        <span className='font-normal text-sm text-gray-dark'>
          {Boolean(description?.length) ? description : 'Body text'}
        </span>
      </div>
      {longDescription?.length && longDescription?.length > 1 && (
        <div className='px-3'>
          <List className='border-1 border-gray-lighter bg-gray-lightest rounded-lg'>
            {longDescription?.map(
              (point: string, index: number) =>
                Boolean(point) && (
                  <ListItem
                    sx={{
                      display: 'flex',
                      gap: 0,
                      padding: 0,
                      alignItems: 'start'
                    }}
                    key={`${point}_${index}`}
                  >
                    <CirleSmall />
                    <Typography
                      variant='body2'
                      sx={{ fontWeight: 400, lineHeight: '1rem', letterSpacing: '0.02rem', marginTop: 1 }}
                    >
                      {point}
                    </Typography>
                  </ListItem>
                )
            )}
          </List>
        </div>
      )}
    </div>
  )
}

export default CalloutCardPreview
